export default __webpack_public_path__ + "static/media/exclaim.e21bf6b0.svg";